export const composeValidators = (...validators) => (formData, props) =>
  validators.reduce((errors, validator) => Object.assign(validator(formData, props) || {}, errors), {});
